const appLink = "https://apps.apple.com/ng/app/skibble/id1633887491";
const androidLink = "https://play.google.com/store/apps/details?id=com.mcfranchostudios.skibble"

export function goToAppleLink(){
    window.open(appLink);
}

export function goToAndroidLink(){
    window.open(androidLink);
}